import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../components/shared/Button/Button';
import Modal from '../../../../components/shared/Modal/Modal.jsx';
import QuillEditor from '../../../../components/shared/QuillEditor/QuillEditor';
import { IsMobile } from '../../../../helpers/IsMobile';

import styles from './About.module.scss';

const customModules = {
  toolbar: {
    container: `#abouteditor`,
  },
  clipboard: { matchVisual: false },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  },
};

const AboutModal = ({ showModal, setShowModal, handleSave, bio }) => {
  const { t } = useTranslation('common');
  const isMobile = IsMobile();
  const [value, setValue] = useState('');

  useEffect(() => {
    if (value !== bio) {
      setValue(bio);
    }
  }, [bio, showModal]);

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={isMobile}
    >
      <Modal.CustomHeader closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{t('account.about')}</Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body>
        <div className={styles.editorCont}>
          <QuillEditor
            value={value}
            setValue={setValue}
            modules={customModules}
            toolbarId="abouteditor"
            label={t('labels.bio')}
          />
        </div>
      </Modal.Body>
      <Modal.CustomFooter>
        <Button variant="primary" onClick={() => handleSave(value)} className={styles.saveBtn} disabled={value === bio}>
          {t('save')}
        </Button>
      </Modal.CustomFooter>
    </Modal>
  );
};

export default AboutModal;
